/** 地形に沿った円・点線など（雷雨エリア、届く範囲、予報の雷雨リスク地域、予約したフライトの線） */
import * as THREE from 'three';

export type HeightFn = (x: number, z: number) => number;

/** 地形に沿った円の頂点列 */
export function drapedCircle(
  cx: number,
  cz: number,
  r: number,
  height: HeightFn,
  lift = 40,
  segments = 72,
): number[] {
  const pts: number[] = [];
  for (let i = 0; i <= segments; i++) {
    const a = (i / segments) * Math.PI * 2;
    const x = cx + Math.cos(a) * r;
    const z = cz + Math.sin(a) * r;
    pts.push(x, height(x, z) + lift, z);
  }
  return pts;
}

/** 頂点列を差し替えられる線 */
export class DynamicLine {
  readonly line: THREE.Line;

  constructor(material: THREE.LineBasicMaterial | THREE.LineDashedMaterial, renderOrder = 12) {
    this.line = new THREE.Line(new THREE.BufferGeometry(), material);
    this.line.frustumCulled = false;
    this.line.renderOrder = renderOrder;
    this.line.visible = false;
  }

  set(points: number[] | null): void {
    if (!points || points.length < 6) {
      this.line.visible = false;
      return;
    }
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(points), 3));
    this.line.geometry.dispose();
    this.line.geometry = geo;
    if (this.line.material instanceof THREE.LineDashedMaterial) this.line.computeLineDistances();
    this.line.visible = true;
  }
}
